import { PowerDeliveryState } from '@vae/server/src/interfaces/eNode/eNodeVehicle.interface'
import React from 'react'
import { useTranslation } from 'react-i18next'

interface ChargeStateDisplayProps {
	powerDeliveryState?: PowerDeliveryState
}

const ChargeStateDisplay: React.FC<ChargeStateDisplayProps> = ({
	powerDeliveryState = 'UNKNOWN',
}) => {
	const { t } = useTranslation('pages_electricCar', { keyPrefix: 'electricCarDetail' })

	// Handle the translation for the state, accounting for keys with colons
	const getStateTranslation = (state: PowerDeliveryState) => {
		switch (state) {
			case 'UNKNOWN':
				return t('chargeStates.UNKNOWN')
			case 'UNPLUGGED':
				return t('chargeStates.UNPLUGGED')
			case 'PLUGGED_IN:INITIALIZING':
				return t('chargeStates.PLUGGED_IN_INITIALIZING')
			case 'PLUGGED_IN:CHARGING':
				return t('chargeStates.PLUGGED_IN_CHARGING')
			case 'PLUGGED_IN:COMPLETE':
				return t('chargeStates.PLUGGED_IN_COMPLETE')
			case 'PLUGGED_IN:STOPPED':
				return t('chargeStates.PLUGGED_IN_STOPPED')
			case 'PLUGGED_IN:NO_POWER':
				return t('chargeStates.PLUGGED_IN_NO_POWER')
			case 'PLUGGED_IN:FAULT':
				return t('chargeStates.PLUGGED_IN_FAULT')
			default:
				return t('chargeStates.UNKNOWN')
		}
	}

	return (
		<div>
			{t('chargingState')}: {getStateTranslation(powerDeliveryState)}
		</div>
	)
}

export default ChargeStateDisplay
